import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../modules/shared/common.styles'

export const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),

  container: {
    padding: [30, 0, 30, 0],
    textAlign: 'center'
  },

  content: {
    maxWidth: '70vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    fontFamily: 'GTWalsheim',

    [theme.media.largeDesktop]: {
      maxWidth: '50vw'
    },
    [theme.media.tablet]: {
      maxWidth: '80vw'
    },
    [theme.media.mobile]: {
      maxWidth: '90vw'
    },
    [theme.media.smallMobile]: {
      maxWidth: '90vw'
    }
  },

  header: {
    fontSize: 40,
    fontWeight: 500,
    marginBottom: 0,

    [theme.media.tablet]: {
      fontSize: 36
    },
    [theme.media.mobile]: {
      fontSize: 36
    },
    [theme.media.smallMobile]: {
      fontSize: 32
    }
  },

  description: {
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 20,

    [theme.media.tablet]: {
      fontSize: 20
    },
    [theme.media.mobile]: {
      fontSize: 20
    },
    [theme.media.smallMobile]: {
      fontSize: 16,
      marginBottom: 5
    }
  }
}))
